<template>
  <div class="page">

    <div class="top">

      <div>
        <!-- Create new partner -->
        <div class="form">
          <form class="form-inline" v-on:submit.prevent="createPartner()">
            <input v-model="name" size="50" placeholder="Partner name"/>
            <button type="submit">Create new</button>
          </form>
        </div>
      </div>
    </div>

    <div class="partners">

      <div class="top">
        <div>
          Partners {{filteredPartners.length}} of {{partners.length}}
        </div>
        <div>
          <button @click="refreshPartners">Refresh</button>
        </div>
      </div>
      <Partner v-for="partner in filteredPartners" :key="partner.id" :partner="partner"/>
    </div>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top {
  display: flex;
  justify-content: space-between;
}
.partners {
  margin-top: 10px;
}
</style>

<script>
import { mapState } from 'vuex'
import Partner from '@/components/Partner.vue'

export default {
  name: 'partners',
  components: {
    Partner
  },
  computed: {
    filteredPartners() {
      return this.partners
    },
    ...mapState([
      'debugMode',
      'partners'
    ])
  },
  methods: {
    refreshPartners () {
      this.$store.dispatch('loadPartners')
    },
    createPartner () {
      if (!this.name) return
      this.$store.dispatch('createPartner', {
        name: this.name
      })
      this.name = ''
    }
  },
  data () {
    return {
      name: ''
    }
  }
}
</script>
